import { FC } from "react";

interface ClockSVGProps {
  width?: number;
  height?: number;
}

const ClockSVG: FC<ClockSVGProps> = ({ width = "18px", height = "18px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.5013 4.66675C8.5013 4.39061 8.27744 4.16675 8.0013 4.16675C7.72516 4.16675 7.5013 4.39061 7.5013 4.66675V8.00008C7.5013 8.17248 7.59011 8.33271 7.7363 8.42408L9.7363 9.67408C9.97047 9.82044 10.2789 9.74925 10.4253 9.51508C10.5717 9.28091 10.5005 8.97244 10.2663 8.82608L8.5013 7.72296V4.66675Z"
        fill="#9999A7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.0013 2.16675C4.77964 2.16675 2.16797 4.77842 2.16797 8.00008C2.16797 11.2217 4.77964 13.8334 8.0013 13.8334C11.223 13.8334 13.8346 11.2217 13.8346 8.00008C13.8346 4.77842 11.223 2.16675 8.0013 2.16675ZM3.16797 8.00008C3.16797 5.33071 5.33193 3.16675 8.0013 3.16675C10.6707 3.16675 12.8346 5.33071 12.8346 8.00008C12.8346 10.6695 10.6707 12.8334 8.0013 12.8334C5.33193 12.8334 3.16797 10.6695 3.16797 8.00008Z"
        fill="#9999A7"
      />
    </svg>
  );
};

export default ClockSVG;
